import type {
  MissionGetListResponse,
  MissionGetDetailResponse,
  UpdateMissionStoreStatusResponse,
  MissionCreateBody,
  MissionCreateResponse,
  MissionUpdateBody,
  MissionUpdateResponse,
  MissionDeleteResponse,
  MissionStoreStatusParams,
  MissionCalendarResponse
} from './model/missionType'

import { jwtClientAxios } from '.'

import api from '@/api/url'

export const createMissionApi = async (body: MissionCreateBody): Promise<MissionCreateResponse> => {
  const response = await jwtClientAxios().post(api.mission.CREATE_AND_LIST, body)
  return response.data
}

export const getMissionListApi = async (params: MissionStoreStatusParams): Promise<MissionGetListResponse> => {
  const response = await jwtClientAxios().get(api.mission.CREATE_AND_LIST, { params })
  return response.data
}

export const getMissionDetailApi = async (mission_id: string): Promise<MissionGetDetailResponse> => {
  const response = await jwtClientAxios().get(api.mission.ONE_MISSION(mission_id))
  return response.data
}

export const updateMissionApi = async (mission_id: string, body: MissionUpdateBody): Promise<MissionUpdateResponse> => {
  const response = await jwtClientAxios().put(api.mission.ONE_MISSION(mission_id), body)
  return response.data
}

export const deleteMissionApi = async (mission_id: string): Promise<MissionDeleteResponse> => {
  const response = await jwtClientAxios().delete(api.mission.ONE_MISSION(mission_id))
  return response.data
}

export const updateMissionStoreStatusApi = async (
  mission_id: string,
  is_stored: boolean
): Promise<UpdateMissionStoreStatusResponse> => {
  const response = await jwtClientAxios().put(
    api.mission.UPDATE_STORE_STATUS(mission_id),
    {},
    { params: { is_stored } }
  )
  return response.data
}

export const getMissionCalendarApi = async (
  mission_id: string,
  page_date?: string // 조회할 달의 날짜 (기본값: 현재 달) YYYY-MM-DD
): Promise<MissionCalendarResponse> => {
  const response = await jwtClientAxios().get(api.mission.CALENDAR(mission_id), { params: { page_date } })
  return response.data
}
